<template>
  <b-modal
    id="absence-doc-modal"
    v-model="localVisible"
    title="Justificante"
    hide-footer
    @hidden="file = null"
  >
    <div v-if="absenceId !== null">
      <div v-if="files && files.length > 0" class="mb-2">
        <p class="mb-1 text-muted" style="font-size:0.9em">Documentos adjuntos:</p>
        <div
          v-for="f in files"
          :key="f.id"
          class="d-flex align-items-center justify-content-between mb-1"
        >
          <div class="d-flex align-items-center">
            <feather-icon icon="FileIcon" class="mr-50 text-primary" />
            <span>{{ f.name }}</span>
          </div>
          <div class="d-flex align-items-center">
            <private-pdf-download
              :pdf-url="f.url"
              :file-name="f.name"
              icon="DownloadIcon"
            />
            <span
              class="ml-1 cursor-pointer text-danger"
              :title="`Eliminar ${f.name}`"
              @click="onRemove(f.id)"
            >
              <feather-icon icon="TrashIcon" size="14" />
            </span>
          </div>
        </div>
        <hr />
      </div>
      <b-form-group label="Añadir documento:">
        <b-form-file
          v-model="file"
          accept="image/*,application/pdf,.doc,.docx"
          placeholder="Selecciona un archivo..."
          browse-text="Examinar"
        />
      </b-form-group>
      <div class="d-flex justify-content-end mt-2">
        <b-button variant="outline-primary" class="mr-1" @click="localVisible = false">Cerrar</b-button>
        <b-button variant="primary" :disabled="!file || loading" @click="onUpload">
          <span v-if="loading">Subiendo...</span>
          <span v-else>Subir</span>
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapActions } from 'vuex'
import { BModal, BFormGroup, BFormFile, BButton } from 'bootstrap-vue'
import PrivatePdfDownload from '@/components/ui/PrivatePdfDownload.vue'

export default {
  name: 'AbsenceDocumentModal',
  components: {
    BModal,
    BFormGroup,
    BFormFile,
    BButton,
    PrivatePdfDownload,
  },
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    absenceId: {
      type: [Number, String],
      default: null,
    },
    files: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      localVisible: false,
      file: null,
      loading: false,
    }
  },
  watch: {
    value(val) {
      this.localVisible = val
    },
    localVisible(val) {
      this.$emit('input', val)
    },
  },
  methods: {
    ...mapActions({
      uploadDocument: 'absences/uploadDocument',
      deleteDocument: 'absences/deleteDocument',
    }),
    async onUpload() {
      if (!this.file) return
      this.loading = true
      try {
        const formData = new FormData()
        formData.append('document', this.file)
        const updated = await this.uploadDocument({ id: this.absenceId, formData })
        if (updated) {
          this.$emit('updated', updated.files)
          this.file = null
        }
      } finally {
        this.loading = false
      }
    },
    async onRemove(fileId) {
      const updated = await this.deleteDocument({ id: this.absenceId, fileId })
      if (updated) {
        this.$emit('updated', updated.files)
      }
    },
  },
}
</script>
